import moment from 'moment'
import React from 'react'
import DatePicker from 'react-datepicker'
import { Label } from 'reactstrap'

const ReactDatePicker = ({
  label,
  selected,
  isClearable,
  onChange,
  showTimeInput,
  showTimeSelect,
  dateFormat,
  disabled,
  placeholder,
  errorMess,
  borderBottomOnly,
  className,
  additionalDayContentData = [],
  onCalendarOpen,
  onMonthChange,
  allowedDates = [],
}) => {
  const renderDayContents = (day, date) => {
    if (!additionalDayContentData.length) return <DayContent day={day} />

    // the API sends plain 'YYYY-MM-DD' days, so comparing formatted strings keeps
    // the match year aware and free of timezone shifts
    const cellDate = moment(date).format('YYYY-MM-DD')
    const target = additionalDayContentData.find(
      (element) => moment.utc(element.date).format('YYYY-MM-DD') === cellDate
    )

    return <DayContent day={day} additionalContent={target ? target.value : ''} />
  }

  const isSelectableDate = (date, allowedDates = []) => {
    if (!allowedDates.length) return true

    const target = moment(date).startOf('day')
    return allowedDates.some((allowedDate) => target.isSame(allowedDate, 'day'))
  }

  return (
    <>
      {label ? <Label className='text-dark'>{label}</Label> : null}
      <DatePicker
        onCalendarOpen={onCalendarOpen}
        onMonthChange={onMonthChange}
        renderDayContents={renderDayContents}
        calendarClassName={showTimeSelect ? 'react-datepicker-custom-class' : ''}
        selected={selected}
        isClearable={isClearable}
        onChange={onChange}
        showTimeSelect={showTimeSelect}
        showTimeInput={showTimeInput}
        dateFormat={!dateFormat ? 'MM/dd/yyyy, hh:mm a' : dateFormat}
        disabled={disabled}
        placeholderText={placeholder}
        className={`${errorMess && 'red-border-datepicker'} ${
          !errorMess && borderBottomOnly && 'border-bottom-only-date-picker '
        }${className || ''}`}
        filterDate={(date) => isSelectableDate(date, allowedDates)}
      />

      <small className='text-danger'>{errorMess}</small>
    </>
  )
}

const DayContent = ({ day, additionalContent, additionalContentStyle = {} }) => {
  return (
    <div style={{ position: 'relative' }}>
      <span>{day}</span>

      {additionalContent && (
        <span
          style={{
            color: 'red',
            position: 'absolute',
            top: '-8px',
            right: '-2px',
            fontSize: '0.7rem',
            ...additionalContentStyle,
          }}
        >
          {additionalContent}
        </span>
      )}
    </div>
  )
}

export default ReactDatePicker
